<template>
  <h2>初めてのコンポーネント</h2>
</template>